// admin/goal/Goals.js

import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

dayjs.locale("pt-br");

export default function GoalTable({ goalOpen }) {
  const [goals, setGoals] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [goalToDelete, setGoalToDelete] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}admin/goal?start_date=2025-08-01&end_date=2030-08-31`,
          { headers }
        );
        setGoals(data);
      } catch (err) {
        console.error("Erro na requisição:", err);
      }
    };

    fetch();
  }, []);

  const numberFormat = (value) =>
    value.toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const goalDelete = async (goalId) => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}admin/goal/${goalId}`,
        { headers }
      );
      setGoals((prevGoals) => prevGoals.filter((goal) => goal.id !== goalId));
    } catch (err) {
      console.error("Erro na requisição:", err);
    } finally {
      setConfirmOpen(false);
      setGoalToDelete(null);
    }
  };

  return (
    <>
      {/* Cabeçalho */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" gutterBottom>
          Metas
        </Typography>
        <Button sx={{ mt: 1 }} onClick={() => goalOpen(null)}>
          Nova
        </Button>
      </Box>

      {/* Tabela */}
      <TableContainer component={Paper} sx={{ borderRadius: 2, mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography fontWeight="bold">Período</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight="bold">Nome</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight="bold">Início</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight="bold">Fim</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight="bold">Meta</Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight="bold">Ação</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {goals
              .slice()
              .sort((a, b) => {
                const dateA = dayjs(`${a.period}-01`);
                const dateB = dayjs(`${b.period}-01`);
                if (!dateA.isSame(dateB)) {
                  return dateB.valueOf() - dateA.valueOf();
                }
                return a.name.localeCompare(b.name, "pt-BR", {
                  sensitivity: "base",
                });
              })
              .map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    {capitalize(dayjs(`${row.period}-01`).format("MMM/YY"))}
                  </TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>
                    {dayjs(row.start_date).format("DD/MM/YY")}
                  </TableCell>
                  <TableCell>{dayjs(row.end_date).format("MM/YY")}</TableCell>
                  <TableCell>{numberFormat(row.target)}</TableCell>
                  <TableCell>
                    <Stack direction="row" spacing={1}>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => goalOpen(row.id)}
                      >
                        <Edit fontSize="small" />
                      </IconButton>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => {
                          setGoalToDelete(row);
                          setConfirmOpen(true);
                        }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog de confirmação */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
      >
        <DialogTitle>Confirmar exclusão</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que deseja excluir a meta{" "} <strong>{goalToDelete?.name}</strong>? 
            <Typography variant="body2" color="textSecondary">
              Essa ação não pode ser desfeita.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={() => goalDelete(goalToDelete.id)}
            color="error"
            variant="contained"
          >
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
